import { Service, AuthConfig, RawAuthConfig } from './models';

const baseName = process.env.REACT_APP_KITRON_BASENAME || '';

export class ApiError extends Error {
    status: number;

    constructor(status: number, message: string) {
        super();
        this.status = status;
        this.message = message;
    }
}

export const getAuthConfig = async (): Promise<AuthConfig> => {
    const code = '7EfWbZ832P1eU634x2PjTVb3Fzdcw7yacu3Qf3XkLXekAxFP';
    const response = await fetch(`${baseName}/api/b2c_config/?code=${code}`, {
        headers: { 'Content-Type': 'application/json' },
        method: 'GET',
    });

    if (!response.ok)
        throw new ApiError(response.status, await response.text());

    const result: RawAuthConfig = await response.json();

    return {
        clientId: result.react_client_id,
        redirectUri: result.react_redirect_uri,
        tenant: result.tenant_name,
        scopes: result.scopes,
        appGroups: result.app_groups,
    };
};

export const checkServiceAccess = async (authCheckUri: string) => {
    const accessToken = sessionStorage.getItem('accessToken');
    const response = await fetch(authCheckUri, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Accept': 'application/json',
        },
        method: 'GET',
    });

    if (!response.ok)
        throw new ApiError(response.status, await response.text());
    return response;
};

export const getServices = async (): Promise<Service[]> => {
    const accessToken = sessionStorage.getItem('accessToken');
    const response = await fetch(`${baseName}/api/business_portal_service/`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Accept': 'application/json',
        },
        method: 'GET',
    });

    if (!response.ok)
        throw new ApiError(response.status, await response.text());
    return response.json();
};
